class EmaMotion extends HTMLElement {
  connectedCallback() {
    if (this._wired) return;
    this._wired = true;
    this.onClick = this.onClick.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.addEventListener('click', this.onClick);
    this.observer = new MutationObserver(this.onSelect);
    this.querySelectorAll('.ema-motion__slide').forEach((slide) => {
      this.observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
  }

  disconnectedCallback() {
    this._wired = false;
    this.removeEventListener('click', this.onClick);
    this.observer?.disconnect();
  }

  onSelect() {
    this.querySelectorAll('.ema-motion__media.is-playing').forEach((media) => {
      if (!media.closest('.ema-motion__slide')?.classList.contains('is-selected')) {
        this.stop(media);
      }
    });
  }

  onClick(event) {
    const trigger = event.target.closest('[data-ema-play]');
    if (!trigger || !this.contains(trigger)) return;
    event.preventDefault();
    const media = trigger.closest('.ema-motion__media');
    if (!media || media.classList.contains('is-playing')) return;
    this.querySelectorAll('.ema-motion__media.is-playing').forEach((item) => this.stop(item));
    this.play(media);
  }

  play(media) {
    const video = media.querySelector('video');
    const frame = media.querySelector('iframe');
    media.classList.add('is-playing');
    if (video) {
      video.muted = false;
      video.controls = true;
      video.play().catch(() => {
        video.muted = true;
        video.play().catch(() => {});
      });
    }
    if (frame && frame.dataset.src) {
      frame.src = frame.dataset.src;
    }
  }

  stop(media) {
    const video = media.querySelector('video');
    const frame = media.querySelector('iframe');
    media.classList.remove('is-playing');
    if (video) {
      video.pause();
      video.currentTime = 0;
      video.controls = false;
    }
    if (frame && frame.dataset.src) {
      frame.src = '';
    }
  }
}

if (!customElements.get('ema-motion')) {
  customElements.define('ema-motion', EmaMotion);
}
